import { Stripe, loadStripe } from "@stripe/stripe-js";
import { config } from "./config";

export let stripeInstance: Stripe | null = null;

loadStripe(config.payment.stripePublishableKey)
  .then((stripe) => stripeInstance = stripe);
